import React from "react";
import Navbar from "../Navbar/Navbar";

const Header = () => {
  return (
    <>
      <Navbar />
    </>
  );
};

export default Header;
